import {cs} from "../../../../../../../../../../react/chain-services";
import {UseState} from "../../../../../../../../../../react/use-state";
import {MasterTable2} from "../../../master-table-2/master-table-2";
import {Expansion} from "../../expansion/expansion";
import * as React from "react";
import {columns} from "../columns";
import {Footer} from "./footer/footer";
import {ConfirmDialog} from "../../../../../../../../common/design2/dialogs/confirm-dialog/confirm-dialog";
import {cascadeSum} from "../../../../../../../../../../utils/cascade";

export const BuildingsTable = (
    {
        buildings,
        onAddBuilding,
        onRemoveBuilding,
        getInitExpandeds=() => [],
        onRemoveAddresses,
        getAddresses = (b) => b.addressList.map((a) => ({key: a.address2, label: a.address + (a.address2 ? ", " + a.address2 : "")})),
        renderBuildingName = b=>b.building.name,
    }
) => cs(
    ["expandeds", (_, next) => UseState({getInitValue: getInitExpandeds, next})],
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    ({expandeds, confirmDialog}) => MasterTable2({
        className: "buildings-table-22d",
        list: buildings.map((b, bi) => ({
            xdQaRowId : 'Coop Condo List ' + renderBuildingName(b),
            // key: "cart|" + cartId,
            columns: [
                {
                    renderCell: () => (
                        <div className="address-4co">
                            <div className="text highlighted-48d" xd-qa-type="label" xd-qa-name={renderBuildingName(b)}>
                                {renderBuildingName(b)}
                            </div>
                            <div className="actions">
                                {expandeds.value.includes(b.building.key) ? (
                                    <a 
                                    onClick={() => expandeds.change((_) => _.filter((k1) => k1 !== b.building.key))} 
                                    xd-qa-type = "link"
                                    xd-qa-name = {`Coop Condo List ${renderBuildingName(b)} Cancel`}
                                    >
                                        Cancel
                                    </a>
                                ) : (
                                    <a 
                                    onClick={() => expandeds.change((_) => [..._, b.building.key])}
                                    xd-qa-type = "link"
                                    xd-qa-name = {`Coop Condo List ${renderBuildingName(b)} Edit`}
                                    >
                                        Edit
                                    </a>
                                )}
                                <a
                                    className="subtle"
                                    onClick={async () => {
                                        const confirm = await confirmDialog.show({
                                            actionName: "remove",
                                            message: "Remove the building from list?",
                                            // buttons: {
                                            //     confirmLabel: "Yes",
                                            // },
                                        })
                                        if (confirm) {
                                            onRemoveBuilding(b.building.key);
                                        }
                                    }}
                                    xd-qa-type = "link"
                                    xd-qa-name = {`Coop Condo List ${renderBuildingName(b)} Remove`}
                                >Remove</a>
                            </div>
                        </div>
                    ),
                    sortValue: () => b.building.name.toLowerCase(),
                },
                {
                    renderCell: () => b.addressList.length,
                    // sortValue: () => firstOrder.branchName.toLowerCase(),
                },
            ],
            getExpansion: expandeds.value.includes(b.building.key) && (({grey}) => cs(
                () => Expansion({
                    addresses: getAddresses(b),
                    addressCount: b.addressList.length,
                    onClose: () => expandeds.change((_) => _.filter((e) => e !== b.building.key)),
                    onRemove: (addrs) => onRemoveAddresses(addrs, b.building.key),
                    grey: !grey,
                }),
            )),
        })),
        columns: columns(),
        getFooter: ({colCount}) => ({
            columns: [{
                colSpan: colCount,
                render: () => Footer({
                    onAddBuilding,
                    onViewAll: () => expandeds.onChange(buildings.map((r) => r.building.key)),
                    summary: {
                        addressesCount: cascadeSum(buildings, "[*].addressList.length"),
                        buildingsCount: buildings.length,
                    },
                }),
            }],
        }),
    }),
);
